module.exports = __webpack_public_path__ + "img/video.ded24500.png";